<template>
    <div class="bar-select">
        <div
          v-if="showFilter"
          class="bar-select--filter"
        >
            <BaseInput
              v-model="filter"
              name="filter"
              label="Filter"
              outlined
              rounded
            />
        </div>
        <div class="bar-select--items">
            <div
                v-for="item in filteredItems" :key="item.label"
                class="bar-select--item"
                @click="changeValue(item.value)"
            >
                <BaseSwitch
                    :data-value="item.value"
                    :name="item.label"
                    :value="isActive(item.value)"
                    @input="changeValue(item.value)"
                    rounded
                ></BaseSwitch>
                <span class="bar-select--label">{{ item.label }}</span>
            </div>
            <div
                v-if="hasError"
                class="input-hint"
            >
                <div
                    v-if="hasError"
                    class="input-hint--error"
                    v-html="errorMessage"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'BarSelect',

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    name: String,
    value: {
      type: Array,
      default: () => ([]),
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    showFilter: {
      type: Boolean,
      default: true,
    },
    layout: {
      type: String,
      default: '1fr 1fr',
    },
    error: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      currentItems: {},
      switches: {},
      filter: '',
    };
  },
  computed: {
    filteredItems() {
      const filter = this.filter.toLowerCase();
      return this.items.filter((item) => item.label.toLowerCase().includes(filter));
    },
    hasError() {
      return !!this.errorMessage;
    },
    errorMessage() {
      return Array.isArray(this.error) && this.error[0] ? this.error[0] : this.error;
    },
  },
  methods: {
    changeValue(val) {
      const { value } = this;

      if (value.includes(val)) {
        value.splice(value.indexOf(val), 1);
      } else {
        value.push(val);
      }

      this.$emit('update', value);
    },
    isActive(val) {
      return this.value.indexOf(val) !== -1;
    },
    setSwitches(value) {
      this.$el.querySelectorAll('.switch').forEach((item) => {
        this.switches[item.dataset.value] = item;
      });
    },
    toggle(value, e) {
      this.setSwitches(value);
      this.switches[value].click();
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-select {
    display: flex;
    flex-direction: column;

    &--filter {
        margin-bottom: 1rem;
    }

    &--items {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: v-bind(layout);
        grid-column-gap: 1rem;
        grid-row-gap: 1rem;

        @media screen and (max-width: 700px) {
            grid-template-columns: 1fr;
        }
    }

    &--item {
        display: flex;
        align-items: center;
        padding: 1rem;
        background-color: #F2F5F8;
    }

    &--label {
        margin-left: 1.5rem;
    }
}
</style>
